var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "236 37.15 40 40",
    enableBackground: "new 236 37.15 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.715038, 0, 0, 5.715038, 409.288757, 277.787231)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M-23.469-40.291c-0.081-0.301-0.317-0.538-0.619-0.619c-0.546-0.146-2.734-0.146-2.734-0.146 s-2.189,0-2.734,0.146c-0.301,0.081-0.538,0.317-0.619,0.619c-0.146,0.546-0.146,1.685-0.146,1.685s0,1.139,0.146,1.685 c0.081,0.301,0.317,0.538,0.619,0.619c0.546,0.146,2.734,0.146,2.734,0.146s2.189,0,2.734-0.146 c0.301-0.081,0.538-0.317,0.619-0.619c0.146-0.546,0.146-1.685,0.146-1.685S-23.323-39.745-23.469-40.291z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-27.523-37.557l1.818-1.05l-1.818-1.05V-37.557z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube);
export default __webpack_public_path__ + "static/media/logo-youtube.99dad3f5d6a2f4523bf3496a4e328d68.svg";
export { ForwardRef as ReactComponent };